export const userKey = 'tomo_user';
export const deviceIdKey = 'tomo_deviceId';
export const passkeyKey = 'tomo_passkey';
